import { Box, Button, DialogActions, DialogContent } from "@material-ui/core";
import { LoadedFile } from "./types";
import { Typography } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { useTranslation } from "react-i18next";
import { FormatErrorItem } from "./ImportView/FileList/styled";

type Props = { selectedFile: LoadedFile; back: () => void };

export default function FormatErrorsView({ selectedFile, back }: Props) {
  const { t } = useTranslation("accounts");
  const { fileName, errors } = selectedFile;

  return (
    <>
      <DialogContent>
        <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
          {t("importAccountsModal.filename", { name: fileName })}
        </Typography>
        {errors.map(({ row, error, column }) => {
          const location = column
            ? t("importAccounts.inRowAndColumn", { number: row, column })
            : t("importAccounts.inRow", { number: row });

          return (
            <FormatErrorItem key={row}>
              <>
                <ErrorOutlineIcon color="error" />
                <Box display="flex" flexDirection="column">
                  <Typography variant="caption">
                    {location} {error}
                  </Typography>
                </Box>
              </>
            </FormatErrorItem>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" size="small" onClick={back}>
          {t("importAccountsModal.goBackBtn")}
        </Button>
      </DialogActions>
    </>
  );
}
